export default () => ({
    auth_token: null,
    status: 'authenticating',
    user: {
        id: null,
        name: null,
        email: null,
        rol: null
    },
})